module.exports = __webpack_public_path__ + "fonts/Gilroy-SemiBoldItalic.e2389bf4.ttf";